import { PerformanceLog } from '@sky-uk-ott/client-lib-js-device';
export { PerfTag, PerfKey } from './perf.enums';
/**
 * @public
 */ export var perfLogger = new PerformanceLog();

//# sourceMappingURL=perf.js.map